function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Capa 1"
}, React.createElement("path", {
  d: "M80.58 115.52V77.81h12.66l1.9-14.7H80.58v-9.38c0-4.25 1.18-7.15 7.28-7.15h7.78V33.42a105.46 105.46 0 0 0-11.34-.58c-11.22 0-18.9 6.85-18.9 19.43v10.84H52.72v14.7h12.69v37.71z",
  fill: "#4065b4"
}), React.createElement("circle", {
  cx: 74.41,
  cy: 74.41,
  r: 71.41,
  fill: "none",
  stroke: "#4065b4",
  strokeMiterlimit: 10,
  strokeWidth: 6
})));

var SvgFacebookIconHighlighted = function SvgFacebookIconHighlighted(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 148.82 148.82",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebookIconHighlighted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FacebookIconHighlighted.eeadd217.svg";
export { ForwardRef as ReactComponent };